export default __webpack_public_path__ + "static/logo-1421bdad9982197f73824ee28680619e.png";